import Utils from "./Customizations"
import developersOneBox from '../../developersOneBox.json'
import oneBoxJson from '../../one-box'
import { wywSearch } from "./wywSearch";
import { versionCompare, getProductFilterFieldByHost } from "./Utils";
let devRules;
let lastDevOneBoxValue;
let oneBoxDevData;

let rules;
let lastOneBoxValue;
let oneBoxData;

let lastTroubleshootValue;
let troubleShootData;

let lastRelatedSearchesValue;
let relatedSearchesData;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export async function fetchDevelopersOneBox (value, host) {
  const sameLastValue = lastDevOneBoxValue ? lastDevOneBoxValue === value : false;

  // if we get the same value as the last time fetchOneBox was called
  // and we already have oneBoxDevData, just return the oneBoxDevData instead
  // of making the API call and/or doing the matching logic
  if (sameLastValue && oneBoxDevData) {
    return oneBoxDevData;
  }

  try {
    if (!devRules) {
      const response = await fetch('https://developers.redhat.com/rhdp-apps/onebox/onebox.json', {'mode': 'no-cors'});

      // devRules = await response.json();
      devRules = developersOneBox
    }

    const findRuleMatch = (value, exactMatch) => {
      let hasRule = false;
      let currRuleInfo = null;

      for (let i = 0; i < devRules.features.length; i += 1) {
        let rule = devRules.features[i];
        let length = rule.match.length;

        for (let j = 0; j < length; j++) {
          if (exactMatch) {
            if (value.toLowerCase() === rule.match[j].toLowerCase()) {
              hasRule = true;
              currRuleInfo = rule;
            }
          } else {
            if (value.indexOf(rule.match[j]) > -1) {
              hasRule = true;
              currRuleInfo = rule;
            }
          }

          if (hasRule) {
            break;
          }
        }
      }

      return currRuleInfo;
    }

    // try to find an exact match first with a
    // strict equals check
    let ruleMatchInfo = findRuleMatch(value, true);

    // if we don't find one, try to locate the value
    // in one of the devRules match array using indexOf
    if (!ruleMatchInfo) {
      ruleMatchInfo = findRuleMatch(value, false);
    }

    oneBoxDevData = {};

    if (!ruleMatchInfo) {
      oneBoxDevData.show = false;
      oneBoxDevData.data = [];
    } else {
      let currData = [{
        title: ruleMatchInfo?.heading?.["text"],
        description: ruleMatchInfo?.details,
        links: ruleMatchInfo?.slots,
      }];
      // developers links can be in slots arr or button obj if it exists
      // need to combine the two to have our full list of one box links

      let oneBoxLinks = ruleMatchInfo?.slots
      if(ruleMatchInfo?.button) {
        oneBoxLinks.push(ruleMatchInfo?.button)
      }
      oneBoxDevData.show = true;
      oneBoxDevData.data = currData;
      oneBoxDevData.displayFeature = "OneBox";
      oneBoxDevData.listings = oneBoxLinks?.map((slot, index) => {
        return {
          displayFeature: 'OneBox',
          displayFeatureTitle:`OneBox: ${ruleMatchInfo?.heading["text"]}`,
          contentTitle: slot?.text,
          contentUrl: slot?.url,
          contentPositionRelative: `${index + 1}`,
          contentID: slot?.url,
        };
      });
    }

    lastDevOneBoxValue = value;
    return oneBoxDevData;
  } catch(error) {
    console.log("one-box error")
    console.log('error', error);
  }
}

const findRuleMatch = (value, rules, exactMatch) => {
  let hasRule = false;
  let currRuleInfo = null;

  for (let i = 0; i < rules?.length; i++) {
    let rule = rules[i];
    let length = rule?.keywords?.length;

    for (let j = 0; j < length; j++) {
      if (exactMatch) {
        if (value.toLowerCase() === rule?.keywords[j].toLowerCase()) {
          hasRule = true;
          currRuleInfo = rule;
        }
      } else {
        if (rule?.keywords[j] && value.toLowerCase().indexOf(rule?.keywords[j].toLowerCase()) > -1) {
          hasRule = true;
          currRuleInfo = rule;
        }
      }

      if (hasRule) {
        break;
      }
    }
  }

  return currRuleInfo;
}

export async function fetchOneBoxConfig (value, host) {
  const sameLastValue = lastOneBoxValue ? lastOneBoxValue === value : false;

  // if we get the same value as the last time fetchOneBox was called
  // and we already have oneBoxData, just return the oneBoxData instead
  // of making the API call and/or doing the matching logic
  if (sameLastValue && oneBoxData) {
    return oneBoxData;
  }

  try {
    if (!rules) {
      const subdomain = window.location.hostname.split('.')[0];
      const response = await fetch(`https://${host}/api/v1/dxp-content/onebox/${subdomain}-redhat-com`);
      const json = await response.json();
      rules = json.data.oneboxes;
    }

    // try to find an exact match first with a strict equals check
    // if we don't find one, try to locate the value in one of the rules keywords array using indexOf
    let ruleMatchInfo = findRuleMatch(value, rules, true) ?? findRuleMatch(value, rules, false);

    oneBoxData = {};

    if (!ruleMatchInfo) {
      oneBoxData.show = false;
      oneBoxData.data = [];
    } else {
      let currData = [{
        title: ruleMatchInfo?.heading,
        description: ruleMatchInfo?.description,
        links: ruleMatchInfo?.links,
      }];

      oneBoxData.show = true;
      oneBoxData.data = currData;
      oneBoxData.displayFeature = "OneBox";
      oneBoxData.listings = ruleMatchInfo?.links?.map((link, index) => {
        return {
          displayFeature: 'OneBox',
          displayFeatureTitle:`OneBox: ${ruleMatchInfo?.heading}`,
          contentTitle: link?.linkText,
          contentUrl: link?.link,
          contentPositionRelative: `${index + 1}`,
          contentID: link?.link,
        };
      });
    }

    lastOneBoxValue = value;
    return oneBoxData;
  } catch(error) {
    console.log('one-box error', error);
  }
}

export async function fetchOneBox (value, host) {
  const sameLastValue = lastOneBoxValue ? lastOneBoxValue === value : false;

  // if we get the same value as the last time fetchOneBox was called
  // and we already have oneBoxData, just return the oneBoxData instead
  // of making the API call and/or doing the matching logic
  if (sameLastValue && oneBoxData) {
    return oneBoxData;
  }

  try {
    if (!rules) {
      // const response = await fetch(oneBoxJson);
      // rules = await response.json();
      rules = oneBoxJson
    }

    const findRuleMatch = (value, exactMatch) => {
      let hasRule = false;
      let currRuleInfo = null;

      for (let i = 0; i < rules?.[0]?.rules?.length; i += 1) {
        let rule = rules?.[0]?.rules[i];
        let length = rule?.keywords?.length;

        for (let j = 0; j < length; j++) {
          if (exactMatch) {
            if (value.toLowerCase() === rule?.keywords[j].toLowerCase()) {
              hasRule = true;
              currRuleInfo = rule;
            }
          } else {
            if (value.indexOf(rule?.keywords[j]) > -1) {
              hasRule = true;
              currRuleInfo = rule;
            }
          }

          if (hasRule) {
            break;
          }
        }
      }

      return currRuleInfo;
    }

    // try to find an exact match first with a
    // strict equals check
    let ruleMatchInfo = findRuleMatch(value, true);

    // if we don't find one, try to locate the value
    // in one of the rules keywords array using indexOf
    if (!ruleMatchInfo) {
      ruleMatchInfo = findRuleMatch(value, false);
    }

    oneBoxData = {};

    if (!ruleMatchInfo) {
      oneBoxData.show = false;
      oneBoxData.data = [];
    } else {
      let currData = [{
        title: ruleMatchInfo?.name,
        description: ruleMatchInfo?.description,
        links: ruleMatchInfo?.links.info,
      }];

      oneBoxData.show = true;
      oneBoxData.data = currData;
      oneBoxData.displayFeature = "OneBox";
      oneBoxData.listings = ruleMatchInfo?.links?.info?.map((link, index) => {
        return {
          displayFeature: 'OneBox',
          displayFeatureTitle:`OneBox: ${ruleMatchInfo?.name}`,
          contentTitle: link?.text,
          contentUrl: link?.link,
          contentPositionRelative: `${index + 1}`,
          contentID: link?.link,
        };
      });
    }

    lastOneBoxValue = value;
    return oneBoxData;
  } catch(error) {
    console.log("one-box error")
    console.log('error', error);
  }
}

export async function executeTroubleShoot(value, host, confidence_threshold) {
  const sameLastValue = lastTroubleshootValue ? lastTroubleshootValue === value : false;

  // if we get the same value as the last time executeTroubleShoot was called
  // and we already have troubleShootData, just return the troubleShootData instead
  // of making the API call
  if (sameLastValue && troubleShootData) {
    return troubleShootData;
  }

  try {
    const response = await fetch(`https://${host}/hydra/rest/search/introspect?query=${value}`)
    const data = await response.json();
    
    troubleShootData = {}
    let troubleshootCardData = [{title: "People also searched for"}]

    if (data.intent === "TROUBLESHOOT" && data.confidence_score >= confidence_threshold) {
      troubleShootData.show = true;
      troubleShootData.displayFeature = "Troubleshoot"
      troubleShootData.data = troubleshootCardData
      troubleShootData.listings = [{
        displayFeature: "Troubleshoot",
        displayFeatureTitle: "Troubleshoot your issue",
        contentTitle: "Troubleshoot your issue",
        contentUrl: "https://access.redhat.com/support/cases/#/troubleshoot",
        contentID: "https://access.redhat.com/support/cases/#/troubleshoot",
        contentPositionRelative: "1",
      }];
    } else {
      troubleShootData.show = false
    }

    lastTroubleshootValue = value;
    return troubleShootData;
  } catch(error) {
    console.log("intent error")
    console.log('error', error);
  }
}



export async function fetchRelatedSearches(value, host) {
  const sameLastValue = lastRelatedSearchesValue ? lastRelatedSearchesValue === value : false;

  // if we get the same value as the last time fetchRelatedSearches was called
  // and we already have relatedSearchesData, just return the relatedSearchesData instead
  // of making the API call
  if (sameLastValue && relatedSearchesData) {
    return relatedSearchesData;
  }

  //fetch related search if query param is single word -- no whitespace
  relatedSearchesData = {};

  if (value.trim().indexOf(' ') === -1 === false) {
    relatedSearchesData.show = false;
    return relatedSearchesData;
  } else {
    try {
      const response = await fetch(`https://${host}/hydra/rest/search/suggestions/related-searches?fq=refined_suggestion_word_count:[2 TO 3]&q=${value}&redhat_client=portal-search&rows=3`)
      const data = await response.json();
      const related = data?.response?.docs.map(d => {
        return {text: d.refined_suggestion, link: `?q=${d.refined_suggestion}`};
      });

      lastRelatedSearchesValue = value;

      if (related.length === 0) {
        relatedSearchesData.show = false;
        return relatedSearchesData;
      } else {
        relatedSearchesData = [{title: "People also searched for", ...related}]
        relatedSearchesData.show = true
        relatedSearchesData.data = relatedSearchesData
        relatedSearchesData.displayFeature = "Recommended"
        relatedSearchesData.listings = related?.map((relatedSearch, index) => {
          return {
            displayFeature: 'Recommended',
            displayFeatureTitle:'People also search for',
            contentTitle: relatedSearch?.text,
            contentUrl: relatedSearch?.link,
            contentPositionRelative: `${index + 1}`,
            contentID: relatedSearch?.link,
          };
        });

        return relatedSearchesData
      }
    } catch(error) {
      console.log("related searches error")
      console.log('error', error);
    }
  }
}

export function getTopDocuments(query, host, results){
  let topDocData = [];

  return new Promise((resolve, reject) => {
    //@ts-ignore
    window?.chrometwo_require(['session'], session => {
      session.onInit(async () => {
        if (!session.isAuthenticated()) {
          resolve(topDocData);
        } else {
          const user = session.getUserInfo();
          const token = session.getEncodedToken();

          try {
            const response = await fetch(`https://${host}/hydra/rest/search/top-documents/users/${user.user_id}?q=${query}`, {
              headers: {
                "Authorization": "Bearer " + token
              }
            });

            const data = await response.json();
            
            resolve({
              topDocuments: data
            });
          } catch(error) {
            resolve(topDocData);
          }
        } 
      });
    });
  });
}

export async function executeSearch (value, HOST, rows, pageNumber, contentTypes = "", version = "", sort = "", products = "", topics = "", listingDriver = "", newSearch = "", productVersionFilterQuery, facetVersionSearchQuery = {}, currentSort) {
  let data = {};
  const url = new URLSearchParams(window.location.search);
  const navSearch = url.get('search-type') === "global" ? true : false

  if(Utils.getHostUrl() === "developers.redhat.com" || Utils.getHostUrl() === "cloud.redhat.com" || Utils.getHostUrl() === "docs.redhat.com"){
  if (newSearch == "newSearch" || navSearch) {
    //ONSITE SEARCH PERFORMED
    //@ts-ignore
    window.appEventData = window.appEventData || [];
    //@ts-ignore
    window.appEventData.push({
      "event": "Onsite Search Performed",
      "onsiteSearch": {
        "keyword": {
          "searchType": navSearch ? "global_search" : "search_page",
          "searchTerm": value,
          "searchMethod": "manual"
        }
      }
    });
    const url = new URL(window.location.href);
    url.searchParams.get("search-type") && url.searchParams.delete("search-type")
    window.history.replaceState({}, "", url.href);
  } else if (listingDriver === "") {
    //@ts-ignore
    window.appEventData = window.appEventData || [];
    //@ts-ignore
    window.appEventData.push({
      "event": "Page Load Search Performed",
      "onsiteSearch": {
        "keyword": {
          "searchType": "search_page",
          "searchTerm": value,
          "searchMethod": "manual"
        }
      }
    });
  }
}

  //encode query param
  value = encodeURIComponent(value)
  // SOLR does not support a start value above 9999
  let startResultIndex = (pageNumber - 1) * rows > 9999 ? 9999 - rows : (pageNumber - 1) * rows;
  // if page number is 1000 or more ...
  if((startResultIndex + rows) > 9999) {
    startResultIndex = startResultIndex - 1;
  }
  try {

    // filter for a documentKind
    // create a tag in the filter query (fq)
    // exclude that tag in facet.filter
    // facet.field=true&fq={!tag=documentKindFilter}documentKind("Course or whatever")&facet.filter={!ex=documentKindFilter}documentKind
    const contentTypeFacetField = `facet.field={!ex=documentKindFilter}documentKind`

    //@ts-ignore
    const urlContentTypes = contentTypes.length > 1 ? contentTypes.join(" OR ") : contentTypes
    const facetQueryContentType = urlContentTypes.length ? `&fq={!tag=documentKindFilter}documentKind:(${urlContentTypes})` : ""

    
    const productFacetField = `&facet.field={!ex=productFilter}${getProductFilterFieldByHost()}`;


    //@ts-ignore
    const urlProducts = products.length > 1 ? products.join(` OR ${getProductFilterFieldByHost()}:`) : products

    const fqProduct = urlProducts.length ? `&fq={!tag=productFilter}${getProductFilterFieldByHost()}:${urlProducts}` : ""

    const topicFacetField = Utils.getHostUrl() === "developers.redhat.com" ? `&facet.field={!ex=topicFilter}topic` : ""
    //@ts-ignore
    const urlTopics = topics.length > 1 ? topics.join(" OR topic:") : topics
    let fqTopic = urlTopics.length ? `&fq={!tag=topicFilter}topic:${encodeURIComponent(urlTopics)}` : "";

    let fQVersionsMerged = { ...productVersionFilterQuery, ...facetVersionSearchQuery }

    //filter out prodcuts with no versions selected - empty strings
    let updatedFqArr = []
    if (products.length > 0) {
      //@ts-ignore
      let productsWithoutQuotes = products?.map(p => p.replaceAll('"', ''))
      for (const product in fQVersionsMerged) {

        //if there are versions associated with a product and the product associated with these versions are present in our active products filter
        //we want to push the fq documentation_version string to our updatedFqArr array which will contain all fq's for documentation_version
        if (fQVersionsMerged[product] !== "" && productsWithoutQuotes.includes(product)) {
          //@ts-ignore
          updatedFqArr.push(fQVersionsMerged[product])
        }
      }
    }
    let fqProductVersion = ""

    //if no products are selected, fqProductVersion becomes an empty string because we should not be querying on any product versions
    if (products.length == 0) {
      fqProductVersion = ""
    }

    //if fq's for documentation_version are present, add them together so we can apply them to our executeSearch fetch call
    if (updatedFqArr.length > 0) {
      updatedFqArr?.forEach(fq => {
        fqProductVersion += `&fq={!tag=productFilter}-(${fq})`
      })
    }

    //only pivot on product and documentation_version if a product filter is active
    const facetPivotString = (products?.length > 0 ? `&facet.pivot={!ex=productFilter, documentVersionFilter}${getProductFilterFieldByHost()},documentation_version&f.documentation_version.facet.sort=index` : "")

    let excludedDocAndId = '&fq=-documentKind:(PortalProduct OR ContainerVendor OR Packages)&fq=-id:Other'
    
    const sortQuery = sort.length && sort !== "relevant" ? `&sort=${sort}` : "";

    let extraFetchParams = ""
    const highlight = Utils.getHostUrl() === "offline-portal" ? `&hl=true&hl.fl=main_content&hl.simple.pre=<mark>&hl.simple.post=<%2Fmark>` : ""

    if (Utils.getHostUrl() === "offline-portal" || Utils.getHostUrl() === "docs.redhat.com") {
      extraFetchParams = `${facetPivotString}&facet.pivot.mincount=1${excludedDocAndId}`
    }

    /*
      We need to parse the documentation_version query param here so that it's available for the SOLR call

      There is going to be a timing issue when multiple versions are selected - we won't have the data back from SOLR to parse through all other versions.
      I think this means that results with multiple versions selected will be unpredictable since not all results have a tagged version


fq: {!tag=productFilter}-(product:"OpenShift Container Platform" AND documentation_version:("4.9"))
fq: {!tag=productFilter}-(product:"OpenShift Container Platform" AND documentation_version:("4.9,4.16"))



    */
    let documentationVersions = new URLSearchParams(window.location.search).get("documentation_version")?.split("&").filter(f => f !== "") || "";
    let numOfDocumentationVersions = documentationVersions[1]?.split(",");
    if (numOfDocumentationVersions?.length === 1) {
      documentationVersions = `&fq={!tag=productFilter}${getProductFilterFieldByHost()}:"${documentationVersions[0]}" AND documentation_version:"${documentationVersions[1]}"`;
    } else {
      documentationVersions = "";
    }
    /*
     * attempting to use the rh_locale cookie for the docs site and
     * falling back to en if the cookie isn't present
     * 
     */
    if (Utils.getHostUrl() === 'docs.redhat.com') {
      const rhLocaleLang = getCookie('rh_locale') || 'en';
      extraFetchParams = `${extraFetchParams}&fq=language:(${rhLocaleLang})`;
    }

    if (Utils.getSearchFields()) {
      extraFetchParams = `${extraFetchParams}&fl=${Utils.getSearchFields()}`;
    }

    let fetchUrl = Utils.getHostUrl() == "offline-portal" ? `http://localhost:8983` : `https://${HOST}`;
 
    if (Utils.getRedHatClient() === 'work-your-way') {
      data = await wywSearch({
        q: value,
        rows,
        start: startResultIndex,
        sort: sortQuery,
      });
    } else {
      const response = await fetch(`${fetchUrl}${Utils.getUrlEndpoint()}?redhat_client=${Utils.getRedHatClient()}&q=${value}&start=${startResultIndex}&rows=${rows}${sortQuery}&facet=true&facet.mincount=1&facet.sort=index&${contentTypeFacetField}${extraFetchParams}&f.${getProductFilterFieldByHost()}.facet.limit=-1${facetQueryContentType}${productFacetField}${fqProduct}${fqProductVersion}${documentationVersions}${topicFacetField}${fqTopic}${highlight}`)    
      data = await response.json()
    }
    let docResults = data?.response?.docs
    //populate facets for content type
    let allContentTypes = data.facet_counts?.facet_fields.documentKind
    const facetsForContentTypes = [];
    for (var i = 0; i < allContentTypes?.length; i += 2) {
      let contentTypesToDisplay = ['Documentation',
        'Solution',
        'Article',
        'Discussion',
        'Video',
        'Blog',
        'LabInfo',
        'ConnectEvent',
        'ConnectTraining',
        'ConnectBlog',
        'ConnectPage',
        'ConnectDocument',
        'Course',
        'News',
        'BlogPost',
        'Concept',
        'Page',
        'documentation',
        'solution',
        'article',
        'errata',
        'Errata',
        'Cve',
        'topic_page',
        'author',
        'video_resource',
        'blog_post',
        'books',
        'cheat_sheet',
        'coding_resource',
        'events',
        'katacoda_individual_lesson',
        'page',
        getProductFilterFieldByHost(),
        'api_catalog',
        'resource',
        'assembly_page',
        'learning_path',
        'openshift_catalog_item',
        'LearningPath',
        'LearningPathResource',
        'product_page',
        'product_sub_page',
      ]
      if (contentTypesToDisplay.includes(allContentTypes[i])) {
        facetsForContentTypes.push({
          heading: allContentTypes[i],
          solrKey: allContentTypes[i],
          numResults: allContentTypes[i + 1]
        });
      }

    }

    //populate facets for documentVersions
    let documentVersions = data?.facet_counts?.facet_pivot?.[`${getProductFilterFieldByHost()},documentation_version`]
    const facetsForDocumentVersions= []

    if (documentVersions?.length > 0) {
      for (var i = 0; i < documentVersions?.length; i += 1) {
        let product = documentVersions[i]?.value
        let versions = []

        for (let j = 0; j < documentVersions[i]?.pivot?.length; j++) {
          let versionNumber = documentVersions[i].pivot[j].value
          //@ts-ignore
          versions.push(versionNumber)
        }
        facetsForDocumentVersions.push({
          [product]: versions.sort(versionCompare)
        });
      }
    }

    //populate facets for products
    let allProducts = data.facet_counts?.facet_fields?.[getProductFilterFieldByHost()];
    const facetsForProducts = [];
    for (var i = 0; i < allProducts?.length; i += 2) {
      facetsForProducts.push({
        heading: allProducts[i],
        solrKey: allProducts[i],
        numResults: allProducts[i + 1]
      });
    }

    let allTopics = []
    let facetsForTopics = []
    if (Utils.getHostUrl() === "developers.redhat.com") {
      //populate facets for products
      allTopics = data.facet_counts?.facet_fields?.topic
      for (var i = 0; i < allTopics?.length; i += 2) {
        facetsForTopics.push({
          heading: allTopics[i],
          solrKey: allTopics[i],
          numResults: allTopics[i + 1]
        });
      }
    }
    //map highlighted text to doc abstarct
    if (Utils.getHostUrl() == "offline-portal"){
      let highlightedTextForUi = []
      for (const doc in docResults){

        let docId = docResults[doc]?.resourceName
        let highlighted_text = data?.highlighting[`${docId}`]?.main_content
        //@ts-ignore
        highlightedTextForUi.push(highlighted_text)

      }

      let index = 0
      docResults.map(result => {
        result.highlightedText = highlightedTextForUi[index++]
      })
    }

    let suggestionsArr = data?.spellcheck?.collations
    //remove first element which is "collation"
    if (suggestionsArr) { 
      suggestionsArr?.shift()
    }


    const filterUrl = new URLSearchParams(window.location.search);
    let contentTypeFilterFromUrl = filterUrl.get('documentKind') || "";
    let productFilterFromUrl = filterUrl.get('product') || "";
    const productVersionFromUrl = filterUrl.get('documentation_version') || "";
    let filterListType = ""
    if(contentTypeFilterFromUrl.length > 0){
      contentTypeFilterFromUrl = contentTypeFilterFromUrl?.split("&")?.join("|documentKind~")
      filterListType += `documentKind~${contentTypeFilterFromUrl}`
    }
    if(productFilterFromUrl.length > 0){
      productFilterFromUrl = productFilterFromUrl.split("&").join(`|${getProductFilterFieldByHost()}~`)
      if(filterListType.length == 0){
        filterListType += `${getProductFilterFieldByHost()}~${productFilterFromUrl}`
      } else {
        filterListType += `|${getProductFilterFieldByHost()}~${productFilterFromUrl}`
      }
    }
    if (productVersionFromUrl.length > 0) {
      let formattedVersions = productVersionFromUrl?.split("&").filter(f => f !== "")
      let versionList = ""
      for(let i = 0; i < formattedVersions.length; i+=2){
        let currProd = formattedVersions[i]
        let currVersions = formattedVersions[i+1]?.split(",")
        for(let j = 0; j < currVersions?.length; j++){
          if(currVersions[j] !== ""){
              versionList += `|documentation-version~${formattedVersions[i]}-${currVersions[j]}`
          }
      
        }
      }
      filterListType += versionList;
    }

    /*
     * temporary fix until redirects from access.redhat.com are pointing
     * to docs.redhat.com
     */
    if (Utils.getHostUrl() === 'docs.redhat.com') {
      const regex = /https:\/\/(access.*redhat.com\/documentation)(\/.*?\/)(.*)/gm;
      
      docResults.map(doc => {
        let host;
        let hostname = new URL(doc.view_uri).hostname;

        switch(hostname) {
          case 'access.qa.redhat.com':
            host = 'docs.qa.redhat.com';
            doc.view_uri = doc.view_uri.replace(regex, `https://${host}/documentation/$3`);
            break;
          case 'access.stage.redhat.com':
            host = 'docs.stage.redhat.com';
            doc.view_uri = doc.view_uri.replace(regex, `https://${host}/documentation/$3`);
            break;
          default:
            host = 'docs.redhat.com';
            doc.view_uri = doc.view_uri.replace(hostname, host); // there will be redirects in production so we just need to swap the hostname
        }

        return doc;
      });
    }

    data.onSuccess = true;
    data.facetInfo = data?.facet_counts
    data.show = true;
    data.displayFeature = "Natural";
    data.data = docResults;
    data.suggestionsArr = suggestionsArr;
    data.docResults = docResults;
    data.facetsForContentTypes = facetsForContentTypes;
    data.facetsForProducts = facetsForProducts;
    data.facetsForTopics = facetsForTopics;
    data.facetsForDocumentVersions = facetsForDocumentVersions;
    data.listings = docResults?.map((doc, index) => {
      return {
        displayFeature: 'Natural',
        displayFeatureTitle: "",
        contentTitle: doc?.publishedTitle || doc?.allTitle,
        contentUrl: doc?.view_uri,
        contentPositionRelative: `${index + 1}`,
        contentID: `${doc?.id}`,
      };
    });
    return data;
  } catch (error) {
    console.log('error', error);
    data.onError = true;
    data.show = false;
    
    return data
  }
}